// The Activity library screen (REQ-243, SCR-592, ADR-114/115): one timeline of the org's audit,
// the guardrail interventions and, on the proxy, the proxy's own audit, under the section's
// sub-tabs Log · Prompt logs. Each shell mounts `ActivityScreen` with the sources it has
// (sources.ts) and its own `subtab` / `subtabHref` (subtabs.tsx's convention).
import type { SubTabDef } from "../../primitives/subtabs";
import type { ScopeMe } from "../../scope/scope";
import { promptLogsVisible, type PromptLoggingState } from "../prompt-logs/model";

/**
 * What Activity's sub-tabs read: the principal, and the org's prompt logging as the shell knows
 * it (on the proxy `/api/me`'s `promptLogging`; on staff the org's settings and `prompts:read`),
 * "loading", "failed" or null while not known.
 */
export interface ActivityScope {
  me: ScopeMe | null;
  promptLogging: PromptLoggingState;
}

export const ACTIVITY_LOG = "log";
export const ACTIVITY_PROMPTS = "prompts";

/** Log · Prompt logs (NAV-042). Prompt logs shows only while the org logs prompts and the principal reads them (REQ-244). */
export const ACTIVITY_SUBTABS: readonly SubTabDef<ActivityScope>[] = [
  { id: ACTIVITY_LOG, label: "Log", visible: () => true },
  { id: ACTIVITY_PROMPTS, label: "Prompt logs", visible: promptLogsVisible },
];

export { ActivityLog, ActivityScreen, EMPTY_MESSAGE as ACTIVITY_EMPTY_MESSAGE, type ActivityLogProps, type ActivityScreenProps } from "./activity";
export { ACTIVITY_KINDS, KIND_LABELS as ACTIVITY_KIND_LABELS, STAFF_ACTOR, type ActivityKind, type ActivityRow } from "./model";
export {
  GUARDRAIL_ERROR_CLASSES,
  guardrailCount,
  guardrailSource,
  orgAuditSource,
  proxyAuditSource,
  type ActivityPage,
  type ActivitySource,
  type GuardrailSourceOptions,
  type PromptHref,
} from "./sources";
